import React from "react";
import { useNavigate } from "react-router-dom";

function Logout() {
  // Navigation
  const navigate = useNavigate();
  const onBtnClick = () => {
    navigate('/login');
    window.location.reload();
    
  };
  return (
    <div className="h-dvh flex items-center flex-col bg-[#545454] ">
      <title>Sign Out | HairBank</title>
      <div className="flex flex-col text-center bg-[#545454] h-screen w-full items-center justify-center">
      <h1 className="text-4xl font-bold  text-[#eed495]">Signed Out Successfully</h1>
      <button 
      className="mt-10 bg-white text-[#545454] w-1/4 text-xl border-2"
      onClick={onBtnClick}>Return to Log in Page</button>
    </div>
    </div>
  );
}

export default Logout;
